import _ from 'lodash'

/**
 * @var {ApiMiddleware}
 */
let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setAttachmentApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        attachments: [],
    },
    getters: {
        attachments: state => state.attachments,
        attachmentByEntityId: state => id => _.filter(state.attachments, { 'project': { id: id } }),
    },
    mutations: {
        setAttachments: (state, attachments) => {
            state.attachments = attachments
            state.synced = true
        },
        addAttachment: (state, newAttachment) => {
            state.attachments.push(newAttachment)
        },
    },
    actions: {
        async attachmentsLoad({ commit }) {
            api.get('/attachment')
                .then(attachments => {
                    commit('setAttachments', attachments)
                })
        },
        async updateAttachment({ commit }, data) {
            return api.put(`/attachment/${data.id}`, data)
                .then(r => {
                    return r
                })
        },
        async createAttachment({ commit }, data) {
            return api.post('/attachment', data)
                .then(result => {
                    result.data = data.data
                    commit('addAttachment', result)
                    return result
                })
        },
    },
})
